import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import cyberSecurityData from '../../../apis/cyberSecurityData';

const inputStyle = {
  height: '30px',
  width: '200px',
  marginBottom: '5px'
}

const AddActorPopup = ({ getActorOptions }) => {
  //redux store state
  const currentUser = useSelector(state => state.currentUser);
  const accessToken = useSelector(state => state.accessToken);
  //comp local
  const [title, setTitle] = useState('');
  const [detailedDescription, setDetailedDescription] = useState('');
  const [url1, setUrl1] = useState('');
  const [mainCategory, setMainCategory] = useState('Actors');
  const [mainCategoryType, setMainCategoryType] = useState('ACTORS');
  const [newTag1, setNewTag1] = useState(currentUser.firstName + ' ' + currentUser.lastName);
  const [newTag2, setNewTag2] = useState('');
  const [newTag3, setNewTag3] = useState('');
  const [newTag4, setNewTag4] = useState('');
  const [newTag5, setNewTag5] = useState('');
  const [newTag6, setNewTag6] = useState('');
  const [newTag7, setNewTag7] = useState('');
  const [newTag8, setNewTag8] = useState('');
  const [newTag9, setNewTag9] = useState('');
  const [newTag10, setNewTag10] = useState('');
  const [newTag11, setNewTag11] = useState('');
  const [newTag12, setNewTag12] = useState('');

  const [error, setError] = useState('');

  const onSaveActorClick = async () => {
    if (!newTag8 || !newTag5) return setError('Please enter Tag 8 & 5');
    else setError('');

    const record = {
      title, detailedDescription, url1, mainCategory, mainCategoryType, newTag1, newTag2, newTag3, newTag4, newTag5, newTag6, newTag7, newTag8, newTag9, newTag10, newTag11, newTag12, exactDate: new Date()
    }

    const actorRecord = {};
    Object.keys(record).forEach(key => {
      if (record[key]) actorRecord[key] = record[key];
    })

    const response = await cyberSecurityData.post('/addnewactor', { actorRecord }, {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })

    getActorOptions();
    document.body.click()
  }

  return (
    <div>
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Title" style={inputStyle} value={title} onChange={e => setTitle(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Description" style={inputStyle} value={detailedDescription} onChange={e => setDetailedDescription(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="url1" style={inputStyle} value={url1} onChange={e => setUrl1(e.target.value)} />

      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 8 (Name)" style={inputStyle} value={newTag8} onChange={e => setNewTag8(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 5 (Country)" style={inputStyle} value={newTag5} onChange={e => setNewTag5(e.target.value)} />

      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 1" style={inputStyle} value={newTag1} onChange={e => setNewTag1(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 2" style={inputStyle} value={newTag2} onChange={e => setNewTag2(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 3" style={inputStyle} value={newTag3} onChange={e => setNewTag3(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 4" style={inputStyle} value={newTag4} onChange={e => setNewTag4(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 6" style={inputStyle} value={newTag6} onChange={e => setNewTag6(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 7" style={inputStyle} value={newTag7} onChange={e => setNewTag7(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 9" style={inputStyle} value={newTag9} onChange={e => setNewTag9(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 10" style={inputStyle} value={newTag10} onChange={e => setNewTag10(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 11" style={inputStyle} value={newTag11} onChange={e => setNewTag11(e.target.value)} />
      <Form.Control className="text-sm" size="sm" type="text" placeholder="Tag 12" style={inputStyle} value={newTag12} onChange={e => setNewTag12(e.target.value)} />

      <div className="text-center">
        <Button className="p-1 m-0 text-sm" variant="primary" size="sm" onClick={onSaveActorClick}>Save Actor</Button>
      </div>
      <div className="text-center">
        {error && <span style={{ color: 'red' }}>{error}</span>}
      </div>
    </div>
  )
}

export default AddActorPopup
